import { Pipe, PipeTransform } from '@angular/core';
import { Provider } from 'src/app/shared/models/withdraw-rial.model';

@Pipe({
  name: 'provider'
})
export class ProviderPipe implements PipeTransform {
  transform(value: Provider, ...args: unknown[]): string {
    switch (value) {
      case 'JIBIT':
        return 'جیبیت';
      case 'VANDAR':
        return 'وندار';
      case 'ZIBAL':
        return 'زیبال';
      case 'NOVINPAL':
        return 'نوین‌پال';
    }
    return value;
  }
}
